module.exports = __webpack_public_path__ + "img/hello_card_pos.4d1f36de.svg";